import { render, staticRenderFns } from "./ClientSlideButton.vue?vue&type=template&id=6b9efa79&scoped=true&"
import script from "./ClientSlideButton.vue?vue&type=script&lang=js&"
export * from "./ClientSlideButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9efa79",
  null
  
)

export default component.exports